import { useQuery } from '@tanstack/react-query'
import { api } from '../api/client'
import type { ShowStats, Stats } from '../api/types'
import { episodeKey, showsKey } from './useShows'

const statsKey = (base: readonly unknown[], days: number) => [...base, 'stats', days] as const

/** How often a show's episodes were downloaded and its feed fetched. */
export function useShowStats(ws: string, showId: string, days = 30) {
  return useQuery({
    queryKey: statsKey([...showsKey(ws), showId], days),
    queryFn: () => api<ShowStats>(`/workspaces/${ws}/shows/${showId}/stats?days=${days}`),
  })
}

export function useEpisodeStats(ws: string, episodeId: string, days = 30) {
  return useQuery({
    queryKey: statsKey(episodeKey(ws, episodeId), days),
    queryFn: () => api<Stats>(`/workspaces/${ws}/episodes/${episodeId}/stats?days=${days}`),
  })
}
